import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';
import { memo } from 'react';

const SvgComponent = (props: SvgProps) => (
  <Svg width={24} height={24} viewBox="0 0 256 256" {...props}>
    <Path fill="none" d="M0 0h256v256H0z" />
    <Path d="M128 24a104 104 0 1 0 104 104A104.2 104.2 0 0 0 128 24Zm37.7 130.3a8.1 8.1 0 0 1 0 11.4 8.2 8.2 0 0 1-11.4 0L128 139.3l-26.3 26.4a8.2 8.2 0 0 1-11.4 0 8.1 8.1 0 0 1 0-11.4l26.4-26.3-26.4-26.3a8.1 8.1 0 0 1 11.4-11.4l26.3 26.4 26.3-26.4a8.1 8.1 0 0 1 11.4 11.4L139.3 128Z" />
  </Svg>
);

const XCircle = memo(SvgComponent);
export default XCircle;
